// extracted by mini-css-extract-plugin
export default {"image":"Membership_image__5jgI3","textContent":"Membership_textContent__PULQy","spacing":"Membership_spacing__X-CD7"};